<!-- simple Modal for canceling a download -->
<!--Copy right - © 2024 tecera gmbh-->

<script>
    import { fade } from "svelte/transition";
    export let is_open;
    export let title;
    export let abort_controller;
    export let current_download_step;
    let is_button_disabled = false;

    function cancel() {
        abort_fetch();
        close();
    }

    function abort_fetch() {
    if (abort_controller) {
        abort_controller.abort();
    }
  }
    function close() {
        is_open = false;
    }
</script>

{#if is_open}
    <div
        class="svelte-modal svelte-backdrop"
        id="confirm_modal"
        tabindex="-1"
        role="dialog"
        display="flex"
        transition:fade={{ duration: 150 }}
    >
        <div
            class="svelte-modal-dialog svelte-modal-dialog-centered"
            role="document"
        >
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="confirmTitle">
                        {title}
                    </h5>
                </div>
                <div class="modal-body" style="height: 175px;">
                    <div class="loader-body-container">
                        <div style="flex 0 0 90%">
                            <div id="loader" class="loader_new" />
                        </div>
                        <div style="flex 0 0 10%" class="mt-2"><p>{current_download_step}</p></div>
                    </div>
                </div>
                <div class="modal-footer" id="edit">
                    <button
                        type="button"
                        class="btn btn-danger"
                        disabled={is_button_disabled}
                        on:click={() => cancel()}>Abbrechen</button
                    >
                </div>
            </div>
        </div>
    </div>
{/if}
